import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import axios from 'axios'
import './assets/css/global.css'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts //挂载到Vue实例上面

import Swiper from "swiper";
import 'swiper/css/swiper.css'
// px2rem 自适应
import 'lib-flexible'


Vue.prototype.$https = axios
axios.defaults.baseURL = 'https://api-nm.caichangyun.com'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
